var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-center scoped-new-questioneditor" },
    [
      _c(
        "transition-group",
        { attrs: { name: "fade" } },
        [
          !_vm.loading
            ? [
                _vm.allowSwitchEditing
                  ? _c(
                      "div",
                      {
                        key: "switch-block",
                        staticClass: "btn-group pull-right clear"
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn ",
                            class: _vm.editQuestionGroup
                              ? "btn-default"
                              : "btn-primary",
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                return _vm.triggerEditQuestionGroup($event)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm._f("translate")("Question group overview")
                                ) +
                                "\n                "
                            )
                          ]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "btn ",
                            class: _vm.editQuestionGroup
                              ? "btn-primary"
                              : "btn-default",
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                return _vm.triggerEditQuestionGroup($event)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm._f("translate")("Question group editor")
                                ) +
                                "\n                "
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    key: "pagetitle-block",
                    staticClass: "pagetitle h3 scoped-unset-pointer-events"
                  },
                  [
                    _vm.isCreateQuestionGroup
                      ? [
                          _c("x-test", {
                            attrs: { id: "action::addQuestionGroup" }
                          }),
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm._f("translate")("Create Question group")
                              ) +
                              "\n                "
                          )
                        ]
                      : [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm._f("translate")("Question group")) +
                              " "
                          ),
                          _c("small", [
                            _vm._v(
                              "(ID: " +
                                _vm._s(
                                  _vm.$store.state.currentQuestionGroup.gid
                                ) +
                                ")"
                            )
                          ])
                        ]
                  ],
                  2
                ),
                this.containsMultipleLanguages
                  ? _c(
                      "div",
                      { key: "languageselector-block", staticClass: "row" },
                      [
                        _c("languageselector", {
                          attrs: {
                            elId: "questiongroup-language-changer",
                            aLanguages: _vm.$store.state.languages,
                            parentCurrentLanguage:
                              _vm.$store.state.activeLanguage
                          },
                          on: { change: _vm.selectLanguage }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    key: "editorcontent-block",
                    staticClass: "row scoped-contain-slider"
                  },
                  [
                    _c(
                      "transition",
                      { attrs: { name: "slide-fade-left" } },
                      [
                        _c("question-group-overview", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !(
                                _vm.editQuestionGroup ||
                                _vm.isCreateQuestionGroup
                              ),
                              expression:
                                "!(editQuestionGroup || isCreateQuestionGroup)"
                            }
                          ],
                          attrs: { event: _vm.event },
                          on: {
                            triggerEvent: _vm.triggerEvent,
                            eventSet: _vm.eventSet
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "transition",
                      { attrs: { name: "slide-fade-left" } },
                      [
                        _c("question-group-editor", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.editQuestionGroup ||
                                _vm.isCreateQuestionGroup,
                              expression:
                                "(editQuestionGroup || isCreateQuestionGroup)"
                            }
                          ],
                          attrs: { event: _vm.event },
                          on: {
                            triggerEvent: _vm.triggerEvent,
                            eventSet: _vm.eventSet
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { key: "questionlist-block", staticClass: "row" },
                  [
                    _c("question-list", {
                      attrs: {
                        event: _vm.event,
                        readonly: !(
                          _vm.editQuestionGroup || _vm.isCreateQuestionGroup
                        )
                      },
                      on: {
                        triggerEvent: _vm.triggerEvent,
                        eventSet: _vm.eventSet
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e()
        ],
        2
      ),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.loading
            ? _c("loader-widget", { attrs: { id: "questiongroupEditLoader" } })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }